<template>
  <div class="yunxiao teacher reserve-list">
    <!-- <search-filter-new
      :campus="params.campusList"
      @clickCampus="chooseCampus"
      :enableDate="true"
      :start="params.startDate | formatDatetime('yyyy-MM-dd')"
      :end="params.endDate | formatDatetime('yyyy-MM-dd')"
      @clickDate="chooseCalendar"
      :enableSearch="false"
      :hasFilter="true"
      @clickFilter="openFilter"
      class="filter">
    </search-filter-new> -->
    <search-filter-new
      :campus="params.campusList"
      :items="searchItems"
      :more="moreOperations"
      @onCampus="chooseCampus"
      @onMore="onSelectOperation"
      @onAdd="$router.push('/classPaiKeAdd?formPage=reserve')"
    >
    </search-filter-new>
    <search-filter-new>
      <date-range-filter
        class="justify-left"
        :start="params.startDate | formatDatetime('yyyy-MM-dd')"
        :end="params.endDate | formatDatetime('yyyy-MM-dd')"
        @clickDate="chooseCalendar"
      />
      <sideFilterItem :hasFilter="true" @clickFilter="openFilter" class="justify-right" />
    </search-filter-new>
    <div class="list-number-line">
      <div class="add-area__info">排课数量：{{totalCount}}</div>
      <div style="color: var(--c1)" @click="$router.push({
        name: 'help-page',
        params: {
          src:'https://bangzhu.xiaogj.com/yxhelp-list/detail-49.html'
        }
      })">约课功能如何使用？</div>
    </div>
    <vx-list
      class="wrapper"
      enable
      :api="$api.courseReserveList"
      :params="listParams"
      ref="listScroller"
      @load="onLoad"
    >
      <div class="items-wrapper">
        <div
          class="item-wrapper"
          v-for="item in list"
          :key="item.id"
          @click="gotoReserveDetails(item)"
          :class="['not-start', 'opening', 'ending'][item.courseReserveStatus]"
        >
          <div class="body">
            <div class="title">
              <div class="l1 normal van-ellipsis">
                <div class="van-ellipsis" v-if="item.courseArrangePlanType === 0">
                  {{ item.className }}
                </div>
                <div class="van-ellipsis" v-else>{{ item.curriculumName }}</div>
              </div>
              <div class="status">
                {{ status[item.courseReserveStatus] }}
              </div>
            </div>
            <div class="l2 van-ellipsis" v-if="getTeacher(item.teacherList) || item.campusName">
              {{[getTeacher(item.teacherList), item.campusName].filter(v=>v).join("·")}}
            </div>
            <div class="l2 has-middle-point van-ellipsis">
              <span>{{ item.courseArrangeStartTime | formatDatetime('MM月dd日') }}</span>
              <span>（{{ weekDays[item.courseArrangeWeekday || 1] }}）</span>
              <span
                >{{ item.courseArrangeStartTime | formatDatetime('hh:mm') }}～{{
                  item.courseArrangeEndTime | formatDatetime('hh:mm')
                }}</span
              >
            </div>
            <div v-if="item.remark" class="colum">
              <div class="icon-line">
                <van-icon class-prefix="vxs-icon" name="pushpin-line" />
              </div>
              <div class="remark-content" :class="{ 'van-ellipsis': !item.fold }">
                {{ item.remark }}
              </div>
              <div
                class="flod"
                :class="{ display: item.fold }"
                @click.stop="$set(item, 'fold', !item.fold)"
              >
                <van-icon name="arrow-down" size="var(--fs-lg)" />
              </div>
            </div>
          </div>
          <div class="footer">
            <span v-if="item.courseReserveStatus === 0"
              >开始时间：{{ item.startTime | formatDatetime('yyyy-MM-dd hh:mm') }}</span
            >
            <span v-if="item.courseReserveStatus === 1"
              >截止时间：{{ item.endTime | formatDatetime('yyyy-MM-dd hh:mm') }}</span
            >
            <span v-if="item.courseReserveStatus === 2">{{ item.cancelRemark }}</span>
            <span>已约课/可约课: {{ item.reservedStudentNum || 0 }}/{{ item.studentNum }} </span>
          </div>
        </div>
      </div>
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        v-if="list.length === 0 && !loading"
        description="没有找到约课信息，点击右上角换个时间试试"
        style="text-align: center"
        image-size="128"
      >
        <van-button
          type="primary"
          square
          round
          v-if="app.permission.op('add_course_reserve')"
          @click="$router.push('/classPaiKeAdd?formPage=reserve')"
        >
          新增约课
        </van-button>
      </van-empty>
    </vx-list>
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import dateRangeFilter from '@x3/vue/filter-comps/date-range-filter.vue';
import sideFilterItem from '@x3/vue/filter-comps/side-filter.vue';
import { openReserveFiltrate } from './filtrate/index.js';

function getInitParams() {
  return {
    // 校区ID集合
    campusIds: [app.teacher.campusId],
    campusList: [app.teacher.campus],
    startDate: new Date(),
    endDate: app.tool.date.getBasedOnToDayDate(7),
    teacherIds: [],
    teacherList: [],
    curriculumId: '',
    curriculumName: '',
    classId: '',
    className: '',
  };
}
export default {
  name: 'reserveList',
  components: {
    SearchFilterNew,
    dateRangeFilter,
    sideFilterItem,
  },
  data() {
    return {
      status: ['未开始', '约课中', '已截止'],
      weekDays: ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      pageTitle: '约课',
      params: getInitParams(),
      list: [],
      totalCount: 0,
      loading: true,
    };
  },
  computed: {
    listParams: function () {
      return Object.assign({}, this.params, {
        startDate: app.tool.date.formatDatetime(this.params.startDate, 'yyyy-MM-dd'),
        endDate: app.tool.date.formatDatetime(this.params.endDate, 'yyyy-MM-dd'),
      });
    },
    moreOperations() {
      let actions = [];
      if (app.permission.op('query_course_reserve_record')) {
        actions.push({ icon: 'jilu', text: '约课记录', id: 1 });
      }
      if (app.permission.op('edit_course_reserve_rule')) {
        actions.push({ icon: 'guize', text: '约课规则', id: 2 });
      }
      return actions;
    },
    searchItems() {
      let arr = ['campus', 'empty-center'];
      if (this.moreOperations.length) {
        arr.push('more');
      }
      if (app.permission.op('add_course_reserve')) {
        arr.push('add');
      }
      return arr;
    },
    attendClassTeachersCampusText: function () {
      let attendClassTeachers = this.obj.courseArrangeTeacherVoList || [];
      let tcs = attendClassTeachers.filter(v=>v.teacherRule === 0).map(v=>v.teacherName);
      if (tcs.length) {
        return tcs.join("、");
      } else {
        return `未设置`
      }
    },
  },
  methods: {
    onLoad(list, res) {
      vant.Toast.clear();
      this.list = list;
      this.totalCount = res && res.page && res.page.totalCount;
      this.loading = false;
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 显示日期选择框
    chooseCalendar() {
      app.x3.picker
        .dateRange({
          startDate: this.params.startDate,
          endDate: this.params.endDate,
          config: {
            type: 2,
          },
          attrs: {
            allowSameDay: true,
            maxDate: app.tool.date.getBasedOnToDayDate(10, 'FullYear'),
          },
        })
        .then(res => {
          Object.assign(this.params, res);
        })
        .catch(() => {
          console.log('取消选择或报错了');
        });
    },
    // 打开筛选
    async openFilter() {
      let res = await openReserveFiltrate({
        params: this.listParams,
      });

      this.params.campusIds = res.params.campusIds;
      this.params.campusList = res.params.campusList;
      this.params.teacherIds = res.params.teacherIds;
      this.params.teacherList = res.params.teacherList;
      this.params.curriculumId = res.params.curriculumId;
      this.params.curriculumName = res.params.curriculumName;
      this.params.classId = res.params.classId;
      this.params.className = res.params.className;
      this.params.startDate = res.params.startDate;
      this.params.endDate = res.params.endDate;
    },
    onSelectOperation(val) {
      switch (val.id) {
        case 1:
          this.$router.push('/reserveLog');
          break;
        case 2:
          this.$router.push('/reserveRules');
          break;
        default:
          break;
      }
    },
    gotoReserveDetails({ courseArrangeId }) {
      this.$router.push('/courseArrange/' + courseArrangeId);
    },
    getTeacher(teachers) {
      let tcs = teachers.filter(v=>v.teacherRule === 0).map(v=>v.teacherName);
      if (tcs.length) {
        return tcs.join("、");
      } else {
        return ''
      }
    }
  },
  created() {
    this.showLoading();
    this.$onBus('reserve-list-refresh', () => {
      this.$refs.listScroller.refresh();
    });
    this.$onBus('reserve-edit-success', () => {
      this.$refs.listScroller.refresh();
    });
    // 停课或者取消停课成功，这里要更新状态
    this.$onBus('course-stop-cancle-success', () => {
      this.$refs.listScroller.refresh();
    });
    this.$onBus('course-arrange-delete-success', () => {
      this.$refs.listScroller.refresh();
    });
    this.$onBus('refresh-arrange-students', () => {
      this.$refs.listScroller.refresh();
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.reserve-list {
  display: flex;
  flex-direction: column;
  .link-nav-line {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: calc(var(--gap) * 8) 0;
    padding: 0 calc(var(--gap) * 16);
    color: var(--tlc);
    > span {
      display: inline-block;
    }
    .vertial-line {
      margin: 0 calc(var(--gap) * 8);
      height: 80%;
      width: 0;
      border-left: 1px solid var(--g5);
    }
  }
  .wrapper {
    flex: 1;
    overflow-y: auto;
    .items-wrapper {
      padding: 0 calc(var(--gap) * 16);
      position: relative;
    }
    .item-wrapper {
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      border-radius: var(--radius-sm);
      background-color: var(--white);
      margin-bottom: calc(var(--gap) * 12);
      .body {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        border-bottom: 1px solid var(--g3);
        .title {
          display: flex;
          > .l1 {
            flex: 1;
          }
          > .status {
            white-space: nowrap;
            color: var(--c2);
          }
        }
      }
      .l1 {
        font-size: 24px;
        line-height: 30px;
        font-weight: var(--bold);
        color: var(--g8);
        &.is-late {
          color: var(--g5);
        }
        &.normal {
          font-size: var(--fs-ex1);
          line-height: var(--lh-ex1);
        }
      }
      .l2 {
        margin-top: calc(var(--gap) * 8);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        display: flex;
        align-items: center;
        &.has-middle-point {
          &::before {
            margin-right: calc(var(--gap) * 8);
            content: '';
            display: inline-block;
            width: calc(var(--w) * 6);
            height: calc(var(--w) * 6);
            background-color: var(--c1);
            border-radius: 50%;
          }
        }
      }
      .footer {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      }
    }
    .item-wrapper.ending {
      color: var(--g5);

      .body > .title > .l1,
      .l2,
      .body > .title > .status {
        color: var(--g5);
      }
      .l2.has-middle-point::before {
        background-color: var(--g5);
      }
    }
    .item-wrapper.not-start {
      .body > .title > .status {
        color: var(--c4);
      }
    }
    .colum {
      position: relative;
      padding: 0 calc(var(--gap) * 24);
      margin-top: calc(var(--gap) * 8);
      height: auto;
      .icon-line {
        left: 0;
        position: absolute;
        height: var(--fs-lg);
        width: var(--fs-lg);
      }
      .remark-content {
        font-size: var(--fs-md);
        line-height: var(--lh-sm);
      }
      .flod {
        position: absolute;
        right: 0;
        height: var(--fs-lg);
        width: var(--fs-lg);
        bottom: calc(var(--gap) * 2);
        > i {
          transition: all 0.3s;
        }
        &.display > i {
          transform: rotateZ(180deg);
        }
      }
    }
  }
}
</style>